import { createFileRoute } from "@tanstack/react-router";
import { useContent } from "@/lib/use-content";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";


export const Route = createFileRoute("/programs")({
  head: () => ({
    meta: [
      { title: "מענים ייחודיים וסדר יום | ישיבת תורת חיים" },
      { name: "description", content: "המענים הייחודיים שאנו מציעים וסדר היום של הישיבה." },
    ],
  }),
  component: Programs,
});

function Programs() {
  const c = useContent("programs");
  return (
    <>
      <section className="bg-primary text-primary-foreground py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="mx-auto mb-4 h-px w-16 bg-gold" />
          <h1 className="font-display text-5xl font-bold">{c.title}</h1>
          <p className="mt-3 text-xl text-gold font-display">{c.subtitle}</p>
        </div>
      </section>

      {c.coverImage && (
        <section className="container mx-auto px-4 pt-10">
          <img src={c.coverImage} alt={c.title} className="rounded-lg shadow-elegant w-full h-auto max-w-5xl mx-auto" loading="lazy" />
        </section>
      )}

      <section className="container mx-auto px-4 py-16">
        <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {c.items.map((item: any, i: number) => (
            <div key={i} className="rounded-lg bg-card shadow-card border border-border/50 hover:shadow-elegant transition-shadow overflow-hidden">
              {item.image && (
                <img src={item.image} alt={item.title} className="w-full h-40 object-cover" loading="lazy" />
              )}
              <div className="p-6">
                <div className="flex h-10 w-10 items-center justify-center rounded-md gradient-gold text-gold-foreground font-display font-bold shadow-card">
                  {i + 1}
                </div>
                <h3 className="mt-4 font-display text-xl font-bold text-primary">{item.title}</h3>
                <p className="mt-2 text-foreground/75 leading-relaxed">{item.text}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="bg-secondary py-16">
        <div className="container mx-auto px-4 max-w-3xl">
          <div className="text-center">
            <div className="mx-auto mb-3 h-px w-12 bg-gold" />
            <h2 className="font-display text-4xl font-bold text-primary">{c.scheduleTitle}</h2>
            <p className="mt-2 text-muted-foreground">{c.scheduleSubtitle}</p>
          </div>

          {c.schedules?.length ? (
            <Tabs defaultValue="0" className="mt-10">
              <TabsList className="mx-auto grid w-full max-w-md grid-cols-2">
                {c.schedules.map((s: any, i: number) => (
                  <TabsTrigger key={i} value={String(i)}>{s.branch}</TabsTrigger>
                ))}
              </TabsList>
              {c.schedules.map((s: any, i: number) => (
                <TabsContent key={i} value={String(i)} className="mt-6">
                  {s.tagline && <p className="text-center text-muted-foreground font-display italic mb-4">{s.tagline}</p>}
                  <ul className="divide-y divide-border rounded-lg bg-card shadow-card overflow-hidden max-w-2xl mx-auto">
                    {s.items.map((it: any, j: number) => (
                      <li key={j} className="flex flex-row-reverse items-center gap-4 px-6 py-4 hover:bg-secondary/50 transition-colors">
                        <span className="font-display text-2xl font-bold text-gold tabular-nums shrink-0 w-20 text-right" dir="ltr">{it.time}</span>
                        <span className="text-foreground flex-1 text-right">{it.label}</span>
                      </li>
                    ))}
                  </ul>
                  {s.note && <p className="mt-4 text-sm text-muted-foreground text-center" dir="rtl">{s.note}</p>}
                </TabsContent>
              ))}
            </Tabs>
          ) : null}
        </div>
      </section>

    </>
  );
}
